import type { Interview } from "@repo/app-types/entities/interview";
import { isNotNullNotUndefined } from "@repo/app-types/helpers/utilities";
import { DropdownMenu } from "@repo/ui/Dropdown/dropdownMenu";
import { SimpleModal, SimpleModalVariant } from "@repo/ui/Modal/modal";
import { IconDotsVertical } from "@tabler/icons-react";
import { type FC, useState } from "react";
import { Button, MenuTrigger } from "react-aria-components";
import { useAppDispatch } from "../../../hooks/hook.js";
import { deleteInterview } from "../interviewsSlice.js";

interface InterviewMoreMenuProps {
  interview: Interview;
  onInterviewDeleteDone: () => void;
}

interface MenuItem {
  label: string;
  onClick: () => void;
}

export const InterviewMoreMenu: FC<InterviewMoreMenuProps> = ({
  interview,
  onInterviewDeleteDone,
}) => {
  const dispatch = useAppDispatch();

  const [isDeleteWarningModalOpen, setIsDeleteWarningModalOpen] =
    useState(false);

  const menuItems: MenuItem[] = [
    {
      label: "Delete this interview",
      onClick: () => setIsDeleteWarningModalOpen(true),
    },
  ].filter(isNotNullNotUndefined);

  return (
    <>
      <div className="relative ml-3">
        <MenuTrigger>
          <Button className="relative flex items-center rounded-md bg-white p-1.5 text-foreground shadow-xs ring-1 ring-border-strong ring-inset hover:bg-gray-50 disabled:bg-slate-300 disabled:text-muted-foreground">
            <span className="absolute -inset-1.5" />
            <span className="sr-only">Open interview menu</span>
            <IconDotsVertical className="h-6 w-6" />
          </Button>
          <DropdownMenu items={menuItems} />
        </MenuTrigger>
      </div>
      <SimpleModal
        isOpen={isDeleteWarningModalOpen}
        variant={SimpleModalVariant.Warning}
        title="Delete interview"
        subtitle="Are you sure you want to delete this interview? This action cannot be undone."
        confirmButtonText="Delete interview"
        onCancel={() => {
          setIsDeleteWarningModalOpen(false);
        }}
        onConfirm={() => {
          dispatch(
            deleteInterview({
              projectId: interview.project_id,
              interviewId: interview.id,
            }),
          );
          setIsDeleteWarningModalOpen(false);
          onInterviewDeleteDone();
        }}
      />
    </>
  );
};
